$(document).ready(function() {
  $('#Product-Slider').on('change.flickity', function(){
    let selected = aavarname[$('.product-images__slide-item.is-selected').attr('data-var')];
    let selectedid = aavarid[$('.product-images__slide-item.is-selected').attr('data-var')];

    if(selected) {
      $('[name="options[Color]"]').val(selected).trigger('change');
      $('[data-type="add-to-cart-form"] input[name="id"]').attr('value', selectedid);
    }
  });
});

$("body").on('DOMSubtreeModified', "#boost-sd__filter-tree-wrapper", function() {
  let searchParams = new URLSearchParams(window.location.search);
  let ptype = searchParams.get('pf_pt_product');

  if (ptype == "Fabric") {
    $('button[aria-label="Filter by: Color"]').addClass('aarif');
  } else {
    $('button[aria-label="Filter by: Color"]').removeClass('aarif');
  }
  
});


// $('.boost-sd__filter-option-itemwrapper .boost-sd__button').click(function() {
//     let searchParams = new URLSearchParams(window.location.search);
//     let ptype = searchParams.get('pf_pt_product');

//     if(ptype == 'Fabric' || ptype == 'Wallpaper'){
        
//     }
// });
